import React, { useState } from "react";
import "./Home.css";

function Home({ onNavigate, isEnglish, theme }) {
  const [openQuestion, setOpenQuestion] = useState(null);

  const title = isEnglish ? "Welcome to DIGISMA" : "اهلا بكم في ديجسما";
  const paragraph = isEnglish
    ? "Turning your ideas into reality through high-quality digital,<br/> services that support the growth of your business.<br/> Relax, leave it to us!"
    : "نقدم خدمات اليكترونيه متطوره تساعدك علي تحقيق اهدافك و تطوير اعمالك";

  // ✅ الأسئلة باللغتين
  const faqs = isEnglish
    ? [
        {
          q: "What services do you offer?",
          a: "At DIGISMA, we provide complete digital solutions to help you stand out and build a strong presence — from professional graphic design, book cover design, and website development to creative content that reflects your brand’s identity.",
        },
        {
          q: "How can I order a service and what payment methods do you accept?",
          a: "It’s simple! Contact us via our website or email, share your requirements, and we’ll send you a clear and detailed quote. We accept payments via bank transfer, PayPal, or any other secure method you prefer, with the option to pay a deposit to start the work.",
        },
        {
          q: "How long will it take to complete my project?",
          a: "We commit to fast delivery without compromising on quality. Most projects are delivered within 3 to 7 days, while larger projects may take longer depending on complexity. You’ll receive regular updates throughout the process.",
        },
        {
          q: "Do you offer revisions and what file formats will I receive?",
          a: "Yes, we offer up to 3 free revisions to ensure you’re completely satisfied with the result, with the option for additional revisions if needed. You’ll receive high-resolution files ready for print and digital use, plus source files if requested.",
        },
        {
          q: "What if I’m not satisfied with the final result?",
          a: "Your satisfaction is our top priority! We work closely with you every step of the way to ensure the design or project perfectly reflects your vision. If there are any concerns, we’ll make every effort to adjust the work until you’re happy with it.",
        },
      ]
    : [
        {
          q: "ما هي الخدمات التي تقدمونها؟",
          a: "في DIGISMA نقدم حلولاً رقمية متكاملة تساعدك على التميز وبناء حضور قوي، من التصميم الجرافيكي الاحترافي، وتصميم الأغلفة، وتطوير المواقع، وصولاً إلى المحتوى الإبداعي الذي يعكس هوية علامتك التجارية.",
        },
        {
          q: "كيف يمكنني طلب خدمة وما طرق الدفع المتاحة؟",
          a: "الأمر بسيط! تواصل معنا عبر الموقع أو البريد الإلكتروني، حدّد احتياجاتك، وسنرسل لك عرضاً واضحاً ومفصلاً. نقبل الدفع عبر التحويل البنكي، باي بال، أو أي وسيلة آمنة أخرى تفضّلها، مع إمكانية دفع جزء مقدم لبدء العمل.",
        },
        {
          q: "كم يستغرق إنجاز المشروع؟",
          a: "نلتزم بسرعة الإنجاز مع الحفاظ على أعلى جودة. أغلب المشاريع تُسلّم خلال 3 إلى 7 أيام، بينما قد تحتاج المشاريع الكبيرة مدة أطول حسب التعقيد، مع تحديثك المستمر بكل خطوة.",
        },
        {
          q: "هل تقدمون مراجعات وما صيغ الملفات التي سأستلمها؟",
          a: "نعم، نقدم حتى 3 مراجعات مجانية للتأكد من أنك راضٍ تماماً عن النتيجة، مع إمكانية إضافة مراجعات إضافية. ستحصل على الملفات النهائية بجودة عالية وجاهزة للطباعة والاستخدام الرقمي، بالإضافة إلى ملفات المصدر إذا رغبت.",
        },
        {
          q: "ماذا يحدث إذا لم أكن راضياً عن النتيجة النهائية؟",
          a: "رضاك أولويتنا القصوى! نحن نعمل معك خطوة بخطوة لضمان أن التصميم أو المشروع يعكس رؤيتك تماماً. في حالة وجود أي ملاحظات، سنبذل قصارى جهدنا لتعديل العمل حتى تصل للنتيجة التي تسعدك.",
        },
      ];

  return (
    <div>
      <main className={`main ${theme}`}>
        <div className="imge">
          <img src="./mains.png" alt=""></img>
        </div>
        <div className="container">
          <h2 dangerouslySetInnerHTML={{ __html: title }} id="main-title"></h2>
          <p
            id="main-paragraph"
            dangerouslySetInnerHTML={{ __html: paragraph }}
          ></p>

          <div
            style={{
              margin: "20px 0",
              display: "flex",
              gap: "10px",
              justifyContent: "center",
            }}
          >
            <button
              className={`secondary-btn ${theme}`}
              onClick={() => onNavigate("projects")}
            >
              {isEnglish ? "Learn More" : "يتعلم أكثر"}
            </button>
          </div>
        </div>
      </main>

      {/* ✅ قسم الأسئلة الشائعة */}
      <section className={`faq-section ${theme}`}>
        <h2 style={{ textAlign: "center", margin: "30px 0" }}>
          {isEnglish ? "Frequently Asked Questions" : "الأسئلة الشائعة"}
        </h2>
        <div className="faq-container">
          {faqs.map((item, index) => (
<div
  key={index}
  className={`faq-card ${theme} ${openQuestion === index ? "open" : ""}`}
  onClick={() =>
    setOpenQuestion(openQuestion === index ? null : index)
  }
>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3>{item.q}</h3>
                <span>{openQuestion === index ? "▲" : "▼"}</span>
              </div>
              {openQuestion === index && (
                <p style={{ marginTop: "10px" }}>{item.a}</p>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;
